import { Injectable } from '@angular/core';

import { Goal } from './goal';
import { GOALS } from './goals';
import { MOCKGOALS } from './mock-goals';

@Injectable()
export class GoalsService {

  getGoals(): Promise<Goal[]> {
    return Promise.resolve(GOALS);
  }

  getMockGoals(): Promise<Goal[]> {
    return Promise.resolve(MOCKGOALS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-goals/goals/goals.service.ts